import { BorderColor, VerticalAlignBottom } from "@mui/icons-material";
import { BsThreeDotsVertical } from "@/Components/Icons/Icons";
import { Divider } from "@mui/material";


export default {
    row1 : [
    {
        column: "column1",
        columnWidth : "100%",
        rows: {
           
            row1: [
                {
                    name: "Commission",
                    actionText: "Shipping Line : ",
                    component: "typographytext",
                    width:"50%",
                    sx:{
                    alignItems: "center"
                    }
                },
                {
                    name: "shippingLine",
                    component: "text-field",
                    gap:false,
                    type:"autocomplete",
                    endpoint: "getShipLineMaster",
                    width : "100%",
                    sx:{
                        width : "300px"                        
                    }
                },
                {
                    name: "addButton",
                    component: "blackbutton",
                    label:"Add",
                },
            ],
        },
    },
]
};


